<script>
  /* External  */
  import FlexSearch from "flexsearch";

  /* Svelte */
  import {  beforeUpdate, afterUpdate, onDestroy } from 'svelte';

  /* Stores */
  import { colorsToSearch } from "../../stores/storeColors";
  import storeGlobal, { storeFilters } from "../../stores/storeGlobal";

  /* Components */
  import Spinner from 'svelte-spinner';
  import Intersect from "../Intersect.svelte";
  import Color from "./Color.svelte";
  import Details from "./Details.svelte";

  /* Lazy Loading */
  let shownItems;
  $: shownItems = $storeGlobal.showItems;


  /* Filter Colors according to searchinput */
  /* create an index for Flexsearch */
  let searchIndex = new FlexSearch({
    tokenize: "forward",
    encode: "icase",
    doc: {
      id: "id",
      field: [
        "content"
      ]
    }
  });

  /* Lifecycle functions */
  beforeUpdate( () => {
    if(searchIndex.length === 0) {
      let c = $colorsToSearch;

      c.forEach( color => {
        searchIndex.add(color);
      })
    }
  })

  onDestroy( () => {
    storeGlobal.updateItem('searchTerm', '');
    storeGlobal.updateItem('showItems', 10);
  })


  /* Searching */
  let results;

  $: currentSearch = $storeGlobal.searchTerm;
  $: filter = $storeFilters;

  $: if (currentSearch) {
    results = searchIndex.search({
      query: currentSearch,
      field: "content",
      where: filter,
      bool: "or"
    })
  } else if (Object.keys(filter).length > 0) {
    results = searchIndex.where( filter )
  } else {
    results = $colorsToSearch;
  }

</script>

<!-- Markup -->
{#if !$colorsToSearch.length}
  <div class="flex justify-center sm:my-24">
    <div class="my-24 text-center">
      <Spinner size="150" thickness="1" gap="45" speed="2000" />
      <p class="text-base mt-4">Loading Colors ... </p>
    </div>
  </div>
{:else}
  <Intersect>
    <ol class="relative
               grid
               grid-cols-normal
               gap-6
               list-none
               lg:grid-cols-large">
      {#each results as color, i (color.id) }
        <Color { color } lazy={ i < shownItems } />
      {/each}
    </ol>
  </Intersect>
{/if}

<!-- ColorDetails -->
{#if $storeGlobal.showDetails }
  <Details />
{/if}
